import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AuditLog, AuditLoggerControllerService } from 'falcon-api';
import { AuditLogFilterRequest } from 'falcon-api/model/auditLogFilterRequest';
import {NGXLogger} from "ngx-logger";
import { FeatureFlags, Features } from 'src/app/core/services/feature-flags.service';
import { IDateOption } from 'src/app/search/models/date-option.interface';
import { FilterFactory } from 'src/app/search/models/filter-factory.interface';
import { AuditDetailComponent } from './audit-detail/audit-detail.component';
import { AllDatesAuditLog } from './options/all-dates';
import { TodayAuditLog } from './options/today';
import { UserNameFilterFactory } from './options/user-name.filter-factory';
import {FacadeService} from "../../shared/services/facade.service";
import { LoadingDialogService } from 'src/app/shared/services/loading-dialog.service';

@Component({
  selector: 'app-logs-audit',
  templateUrl: './logs-audit.component.html',
  styleUrls: ['./logs-audit.component.scss']
})
export class LogsAuditComponent implements OnInit {
  dateOptions: IDateOption[] = [];
  filterFactories: FilterFactory[] = [];
  displayedColumns: string[] = ['userName', 'action', 'createdDate'];
  showEmptyResultMessage = false;
  dataSource: MatTableDataSource<AuditLog> = new MatTableDataSource<AuditLog>([]);
  totalElements: number = 0;
  query = "";
  private paginator!: MatPaginator;
  @ViewChild('paginator') set matPaginator(paginator: MatPaginator) {
    this.paginator = paginator;
    this.initPaginator();
  }
  private sort!: MatSort;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.sort = sort;
    this.initSort();
  };

  /**
   * Constructor
   * @param logger Logger instance
   * @param dialog Mat Dialog instance
   * @param logControllerService Log controller service
   * @param featureFlagService Feature flag service
   * @param router Router instance
   * @param facadeService Facade service
   */
  constructor(
    private logger: NGXLogger,
    private dialog: MatDialog,
    private logControllerService: AuditLoggerControllerService,
    private featureFlagService: FeatureFlags,
    private router: Router,
    private facadeService: FacadeService,
    private loadingDialogService: LoadingDialogService
  ) {
    this.dateOptions.push(new AllDatesAuditLog());
    this.dateOptions.push(new TodayAuditLog());

    this.filterFactories.push(new UserNameFilterFactory());

    this.facadeService.setPageTitleContext("Audit Logs");
  }

  /**
   * Init
   */
  ngOnInit(): void {
    this.loadingDialogService.openDialog();
    if(!this.featureFlagService.isFeatureEnabled(Features.AuditLog)){
      this.router.navigate(['/']);
    }
  }

  openDetail(logEntry: AuditLog): void {
    this.dialog.open(AuditDetailComponent, {
      data: {
        logEntry
      }
    });
  }

  queryBuilt(query: string) {
    this.loadingDialogService.openDialog();
    this.showEmptyResultMessage = false;
    this.query = query;
    const request: AuditLogFilterRequest = {
      filter: query
    };

    if (!(this.paginator && this.sort)) {
      this.logControllerService.search(request).subscribe(response => {
        if (response.totalElements === 0) {
          this.showEmptyResultMessage = true;
          return;
        }

        this.dataSource.data = response.content!;
        this.loadingDialogService.hideDialog();
        this.totalElements = response.totalElements!;
      });

      return;
    }

    this.paginator.pageIndex = 0;
    this.refreshData();
  }

  refreshData(): void {
    this.showEmptyResultMessage = false;
    const request: AuditLogFilterRequest = {
      filter: this.query
    };
    const pageNumber = this.paginator.pageIndex + 1;
    const pageSize = this.paginator.pageSize;
    const sortBy = this.sort.active;
    const sortDirection = this.sort.direction;

    this.logControllerService.search(request, sortBy, sortDirection, pageSize, pageNumber).subscribe(response => {
      if (response.totalElements === 0) {
        this.showEmptyResultMessage = true;
        return;
      }

      this.dataSource.data = response.content!;
      this.loadingDialogService.hideDialog();
      this.totalElements = response.totalElements!;
    });

  }

  initPaginator(): void {
    this.paginator.page.subscribe(() => {
      this.refreshData();
    })
  }

  initSort(): void {
    this.sort.sortChange.subscribe(() => {
      this.refreshData();
    });
  }
}
